module.exports = __webpack_public_path__ + "static/media/Helvetica-Bold-01.591c8cb5.svg";